/**
 * Main Product Grid integration file
 * Serves as the entry point that ties all modules together
 */

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing draggable products and 3D model');
  
  // Make functions available globally
  window.ProductGrid = {
    init: function() {
      // This will be called from the Shopify theme
      console.log('ProductGrid.init() called');
      
      // Make sure we have all required elements
      const container = document.getElementById('product-grid-container');
      const grid = document.getElementById('product-grid');
      
      if (!container || !grid) {
        console.error('Required grid elements not found');
        return;
      }
      
      // Each module has its own initialization
      if (typeof window.GridCore !== 'undefined') {
        console.log('Core module found, initializing...');
        // Core module will initialize other modules in sequence
      } else {
        console.error('Core module not loaded, cannot initialize product grid');
      }
    },
    
    regeneratePositions: function() {
      if (window.ProductCards && typeof window.ProductCards.randomizePositions === 'function') {
        window.ProductCards.randomizePositions();
      }
      
      if (window.ThreeDModel && typeof window.ThreeDModel.positionModelRandomly === 'function') {
        window.ThreeDModel.positionModelRandomly();
      }
    }
  };
});
